import React from 'react';

import { styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Slider from 'react-slick';

import imgSlide12X from 'assets/images/login-carousel-slide-1-2x.png';
import imgSlide1 from 'assets/images/login-carousel-slide-1.png';
import imgSlide22X from 'assets/images/login-carousel-slide-2-2x.png';
import imgSlide2 from 'assets/images/login-carousel-slide-2.png';
import imgSlide32X from 'assets/images/login-carousel-slide-3-2x.png';
import imgSlide3 from 'assets/images/login-carousel-slide-3.png';
import imgSlide42X from 'assets/images/login-carousel-slide-4-2x.png';
import imgSlide4 from 'assets/images/login-carousel-slide-4.png';
import imgSlide52X from 'assets/images/login-carousel-slide-5-2x.png';
import imgSlide5 from 'assets/images/login-carousel-slide-5.png';
import logo from 'assets/images/logos/finalcad-logo-text-dark.svg';
import CarouselArrowButton from 'components/Carousel/components/CarouselArrowButton';
import ChevronLeft from 'components/SvgComponents/icons/ChevronLeft';
import ChevronRight from 'components/SvgComponents/icons/ChevronRight';
import LoginCarouselItem from 'containers/LoginPage/components/LoginCarouselItem';
import globalMessages from 'translations/messages/global-messages';

const Div_Wrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  height: '100vh',
  '& .login-container-left-container': {
    backgroundColor: theme.palette.custom.login.background,
    '& .login-container-left-container-carousel': {
      height: '75%',
    },
    '& .login-container-left-container-logo-wrapper': {
      height: '25%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        height: '25%',
        marginRight: 40,
      },
    },
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    '& .login-container-left-container': {
      display: 'none',
    },
  },
}));

const Slider_Custom = styled(Slider)(({ theme }) => ({
  position: 'relative',
  '& .slick-prev': {
    left: theme.spacing(2),
  },
  '& .slick-next': {
    right: theme.spacing(2),
  },
  '& .slick-prev:before, & .slick-next:before': {
    content: '""',
  },
  '& .slick-prev, & .slick-next': {
    width: 32,
    height: 32,
    zIndex: 1,
    borderRadius: '50%',
    background: 'transparent',
    '& svg': {
      color: theme.palette.text.primary,
      width: 16,
      height: 16,
    },
    '&:hover': {
      border: `1px solid ${theme.palette.text.dark}`,
      cursor: 'pointer',
      '& svg': {
        color: theme.palette.text.dark,
      },
    },
  },
}));

const LoginContainer = ({ children }) => {
  const intl = useIntl();
  const items = [
    {
      image: imgSlide1,
      image2x: imgSlide12X,
      title: intl.formatMessage(globalMessages.onBoarding_title1),
      description: intl.formatMessage(globalMessages.onBoarding_description1),
    },
    {
      image: imgSlide2,
      image2x: imgSlide22X,
      title: intl.formatMessage(globalMessages.onBoarding_title2),
      description: intl.formatMessage(globalMessages.onBoarding_description2),
    },
    {
      image: imgSlide3,
      image2x: imgSlide32X,
      title: intl.formatMessage(globalMessages.onBoarding_title3),
      description: intl.formatMessage(globalMessages.onBoarding_description3),
    },
    {
      image: imgSlide4,
      image2x: imgSlide42X,
      title: intl.formatMessage(globalMessages.onBoarding_title4),
      description: intl.formatMessage(globalMessages.onBoarding_description4),
    },
    {
      image: imgSlide5,
      image2x: imgSlide52X,
      title: intl.formatMessage(globalMessages.onBoarding_title5),
      description: intl.formatMessage(globalMessages.onBoarding_description5),
    },
  ];
  return (
    <Div_Wrapper>
      <div className="login-container-left-container">
        <div className="login-container-left-container-carousel">
          <Slider_Custom
            centerMode
            dots={false}
            adaptiveHeight={false}
            slidesToShow={1}
            slidesToScroll={1}
            centerPadding={0}
            autoplay
            infinite
            speed={1000}
            autoplaySpeed={10000}
            pauseOnHover={false}
            prevArrow={<CarouselArrowButton icon={<ChevronLeft />} />}
            nextArrow={<CarouselArrowButton icon={<ChevronRight />} />}
          >
            {items.map(item => <LoginCarouselItem key={item.title} {...item} />)}
          </Slider_Custom>
        </div>
        <div className="login-container-left-container-logo-wrapper">
          <img src={logo} alt={intl.formatMessage(globalMessages.finalcad_one_web_app)} />
        </div>
      </div>
      {children}
    </Div_Wrapper>
  );
};

LoginContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginContainer;
